<template>
  <div class="auth-layout-wrap">
    <div style="width: 450px;" class="col-12">
      <div class="card mb-4 text-center p-2">
        <div class="card-body">
          <!-- Logo -->
          <div class="mb-4">
            <img
              src="https://www.takafulbrunei.com.bn/wp-content/uploads/2016/11/logo-tb-1.png"
              alt="Takaful Brunei"
              style="width: 50%;"
            />
          </div>

          <!-- Form -->
          <!-- <h1 class="mb-3 text-18">Forgot Password</h1> -->
          <div class="form-group mb-3">
            <label for="email">Email</label>
            <input class="form-control" type="email" name="email" id="email" />
          </div>

          <!-- Button -->
          <button class="btn btn-rounded btn-primary btn-block mt-3">
            Reset Password
          </button>

          <!-- Cancel -->
          <div class="mt-3">
            <a href="/login" class="text-muted"><u>Cancel</u></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "forgot_password",
  components: {},

  data() {
    return {};
  },

  methods: {}
};
</script>
